export default "__VITE_ASSET__CCG1LbB9__"